!(function () {
  var t,
    e = {
      1092: function (t, e, i) {
        "use strict";
        i.d(e, {
          M: function () {
            return s;
          },
        });
        var n = i(6072),
          r = i(1717);
        document.addEventListener("DOMContentLoaded", function () {
          document.querySelectorAll(".icon").forEach((t) => {
            t.classList.add("loaded");
          }),
            document.querySelectorAll('a[target="_blank"]').forEach((t) => {
              t.innerHTML =
                t.innerHTML +
                '<span class="visually-hidden"> ' +
                accessibilityNoticeNewTab +
                "</span>";
            }),
            (0, r.f)();
        }),
          void 0 !== window.BOOMR &&
            console.log(
              "Built with " +
                window.BOOMR.themeName +
                " (https://themes.shopify.com/themes/align/) version " +
                window.BOOMR.themeVersion +
                " by Company XYZ (https://companyxyz.io/)."
            ),
          void 0 === window.Shopify && (window.Shopify = {}),
          (Shopify.bind = function (t, e) {
            return function () {
              return t.apply(e, arguments);
            };
          }),
          (Shopify.setSelectorByValue = function (t, e) {
            for (var i = 0, n = t.options.length; i < n; i++) {
              var r = t.options[i];
              if (e == r.value || e == r.innerHTML)
                return (t.selectedIndex = i), i;
            }
          }),
          (Shopify.addListener = function (t, e, i) {
            t.addEventListener
              ? t.addEventListener(e, i, !1)
              : t.attachEvent("on" + e, i);
          }),
          (Shopify.postLink = function (t, e) {
            var i = (e = e || {}).method || "post",
              n = e.parameters || {},
              r = document.createElement("form");
            for (var s in (r.setAttribute("method", i),
            r.setAttribute("action", t),
            n)) {
              var o = document.createElement("input");
              o.setAttribute("type", "hidden"),
                o.setAttribute("name", s),
                o.setAttribute("value", n[s]),
                r.appendChild(o);
            }
            document.body.appendChild(r),
              r.submit(),
              document.body.removeChild(r);
          }),
          (Shopify.CountryProvinceSelector = function (t, e, i) {
            (this.countryEl = document.getElementById(t)),
              (this.provinceEl = document.getElementById(e)),
              (this.provinceContainer = document.getElementById(
                i.hideElement || e
              )),
              Shopify.addListener(
                this.countryEl,
                "change",
                Shopify.bind(this.countryHandler, this)
              ),
              this.initCountry(),
              this.initProvince();
          }),
          (Shopify.CountryProvinceSelector.prototype = {
            initCountry: function () {
              var t = this.countryEl.getAttribute("data-default");
              Shopify.setSelectorByValue(this.countryEl, t),
                this.countryHandler();
            },
            initProvince: function () {
              var t = this.provinceEl.getAttribute("data-default");
              t &&
                this.provinceEl.options.length > 0 &&
                Shopify.setSelectorByValue(this.provinceEl, t);
            },
            countryHandler: function (t) {
              var e = (r =
                  this.countryEl.options[
                    this.countryEl.selectedIndex
                  ]).getAttribute("data-provinces"),
                i = JSON.parse(e);
              if ((this.clearOptions(this.provinceEl), i && 0 == i.length))
                this.provinceContainer.style.display = "none";
              else {
                for (var n = 0; n < i.length; n++) {
                  var r;
                  ((r = document.createElement("option")).value = i[n][0]),
                    (r.innerHTML = i[n][1]),
                    this.provinceEl.appendChild(r);
                }
                this.provinceContainer.style.display = "";
              }
            },
            clearOptions: function (t) {
              for (; t.firstChild; ) t.removeChild(t.firstChild);
            },
            setOptions: function (t, e) {
              var i = 0;
              for (e.length; i < e.length; i++) {
                var n = document.createElement("option");
                (n.value = e[i]), (n.innerHTML = e[i]), t.appendChild(n);
              }
            },
          }),
          document.querySelectorAll("video").forEach((t) => {
            t.muted = !0;
            let e = t.play();
            void 0 !== e &&
              e.then((e) => {
                new IntersectionObserver(
                  (e) => {
                    e.forEach((e) => {
                      e.isIntersecting
                        ? 1 == t.autoplay && t.paused && t.play()
                        : t.paused || t.pause();
                    });
                  },
                  { threshold: 0 }
                ).observe(t);
              });
          }),
          document.querySelectorAll("video.hover-play").forEach((t) => {
            const e = t.closest(".card");
            t.pause(),
              e
                ? (e.addEventListener("mouseenter", () => {
                    t.play();
                  }),
                  e.addEventListener("mouseleave", () => {
                    t.pause();
                  }))
                : (t.addEventListener("mouseenter", () => {
                    t.play();
                  }),
                  t.addEventListener("mouseleave", () => {
                    t.pause();
                  }));
          });
        const s = function () {
          [].slice.call(document.querySelectorAll("video")).forEach((t) => {
            const e = t.parentElement.querySelector(".figure--video__poster");
            e &&
              e.addEventListener("click", () => {
                e.classList.add("hidden"), t.play();
              });
          });
          var t = [].slice.call(
            document.querySelectorAll(".figure--video-external")
          );
          if ("IntersectionObserver" in window) {
            var e = new IntersectionObserver(function (t, e) {
              t.forEach(function (t) {
                if (t.isIntersecting)
                  "vimeo" == t.target.dataset.type &&
                    fetch(
                      "http://vimeo.com/api/v2/video/" +
                        t.target.dataset.id +
                        ".json"
                    )
                      .then((t) => {
                        if (!t.ok) throw new Error(`HTTP error ${t.status}`);
                        return t.json();
                      })
                      .then((e) => {
                        t.target.querySelector(
                          ".figure--video__external-poster-image"
                        ).src = e[0].thumbnail_large;
                      }),
                    t.target.addEventListener("click", function () {
                      if (!t.target.querySelector("iframe")) {
                        let t = this.dataset.type,
                          e = document.createElement("iframe");
                        e.setAttribute("frameborder", "0"),
                          e.setAttribute("allowfullscreen", ""),
                          e.setAttribute("allow", "autoplay"),
                          "youtube" == t
                            ? (e.setAttribute("id", "youtube"),
                              e.setAttribute(
                                "src",
                                "https://www.youtube.com/embed/" +
                                  this.dataset.id +
                                  this.dataset.videotags +
                                  "rel=0&showinfo=0&autoplay=1"
                              ))
                            : e.setAttribute(
                                "src",
                                "https://player.vimeo.com/video/" +
                                  this.dataset.id +
                                  this.dataset.videotags +
                                  "rel=0&showinfo=0&autoplay=1"
                              ),
                          this.appendChild(e),
                          setTimeout(() => {
                            this.querySelector(
                              ".figure--video__poster"
                            ).classList.add("hidden");
                          }, 350);
                      }
                    });
                else if (t.target.querySelector("iframe")) {
                  let i = t.target.dataset.type,
                    n = t.target.querySelectorAll("iframe");
                  if ("youtube" == i) {
                    var e = { event: "command", func: "pauseVideo" };
                    n[0].contentWindow.postMessage(JSON.stringify(e), "*");
                  } else
                    "vimeo" == i &&
                      ((e = { method: "pause", value: "true" }),
                      n[0].contentWindow.postMessage(JSON.stringify(e), "*"));
                }
              });
            });
            t.forEach(function (t) {
              e.observe(t);
            });
          }
        };
        s(),
          window.addEventListener("beforeprint", () => {
            const t = document.body.querySelectorAll("details"),
              e = document.body.querySelectorAll("img");
            for (let e = 0; e < t.length; e++)
              t[e].open
                ? (t[e].dataset.open = "1")
                : t[e].setAttribute("open", "");
            for (let t = 0; t < e.length; t++) e[t].dataset.open = "1";
          }),
          window.addEventListener("afterprint", () => {
            const t = document.body.querySelectorAll("details");
            for (let e = 0; e < t.length; e++)
              t[e].dataset.open
                ? (t[e].dataset.open = "")
                : t[e].removeAttribute("open");
          }),
          Shopify.designMode &&
            document.addEventListener("shopify:section:load", () => {
              s(),
                document.querySelectorAll(".icon").forEach((t) => {
                  t.classList.add("loaded");
                });
            });
        class o extends HTMLElement {
          constructor() {
            super(),
              this.addEventListener("change", this.onVariantChange),
              (this.isCardBasedProductForm =
                null !== this.closest(".card__content"));
          }
          connectedCallback() {
            (this.mainProductUniqueIdentifier =
              "main-product-" + this.dataset.product),
              (this.uniqueIdentifier =
                this.dataset.section + "-" + this.dataset.product);
          }
          onVariantChange() {
            this.updateOptions(),
              this.updateMasterId(),
              this.currentVariant
                ? (this.updateVariantStatuses(),
                  this.updateImageSwatches(),
                  this.updateMedia(),
                  this.updateURL(),
                  this.updateLinks(),
                  this.renderProductInfo(),
                  this.updateVariantInput(),
                  this.updateAddToCart())
                : void 0 === this.currentVariant && this.setUnavailable();
          }
          updateOptions() {
            this.options = Array.from(
              this.querySelectorAll("select, fieldset"),
              (t) => {
                return "SELECT" === t.tagName
                  ? t.value
                  : "FIELDSET" === t.tagName
                  ? null ===
                      (e = Array.from(t.querySelectorAll("input")).find(
                        (t) => t.checked
                      )) || void 0 === e
                    ? void 0
                    : e.value
                  : void 0;
                var e;
              }
            );
          }
          updateMasterId() {
            this.options.includes(void 0)
              ? (this.currentVariant = null)
              : (this.currentVariant = this.getVariantData().find(
                  (t) =>
                    !t.options.map((t, e) => this.options[e] === t).includes(!1)
                ));
          }
          updateVariantStatuses() {
            const t = this.querySelector(":checked").value,
              e = this.getVariantData().filter((e) => e.options[0] === t);
            this.getProductVariantSelects().forEach((t) => {
              const i = t.querySelectorAll("select, fieldset");
              i.forEach((t, n) => {
                if (0 === n) return;
                const r = t.querySelectorAll('input[type="radio"], option'),
                  s = i[n - 1].querySelector(":checked").value,
                  o = e
                    .filter((t) => t.available && t[`option${n}`] === s)
                    .map((t) => t[`option${n + 1}`]);
                this.setInputAvailability(r, o);
              });
            });
          }
          setInputAvailability(t, e) {
            t.forEach((t) => {
              const i = t.getAttribute("value"),
                n = e.includes(i);
              "OPTION" === t.tagName &&
                (t.innerText = n
                  ? i
                  : window.productStrings.unavailable_with_option.replace(
                      "[value]",
                      i
                    ));
            });
          }
          updateImageSwatches() {
            this.querySelectorAll("fieldset:has(.image-swatch)").forEach(
              (t) => {
                const e = t.dataset.optionPosition,
                  i = t.querySelectorAll(".image-swatch");
                for (const t of i) {
                  const i = [...this.options];
                  i[e - 1] = t.value;
                  const n = this.getVariantData().find(
                    (t) =>
                      t.options[0] == i[0] &&
                      t.options[1] == i[1] &&
                      t.options[2] == i[2]
                  );
                  if (!n) continue;
                  const r = t.labels[0],
                    s = r.querySelectorAll("img.variant-image"),
                    o = r.querySelector(`img[data-variant-id="${n.id}"]`),
                    a = r.querySelector(".image_swatch--text_value");
                  s.forEach((t) => {
                    t.classList.add("hidden");
                  }),
                    a.classList.add("u-hide"),
                    o
                      ? o.classList.remove("hidden")
                      : a.classList.remove("u-hide");
                }
              }
            );
          }
          updateMedia() {
            if (!this.currentVariant) return;
            if (!this.currentVariant.featured_media) return;
            const t = document.querySelector(
                `#gallery-${this.uniqueIdentifier}`
              ),
              e = t.dataset.variantStyle;
            if (this.currentVariant.featured_media) {
              const i = this.currentVariant.featured_media.id;
              if ("default" == e)
                if (t.swiper) {
                  const e = t.swiper.slides,
                    n = Array.from(e).findIndex((t) => t.dataset.id == i);
                  -1 !== n && t.swiper.slideToLoop(n);
                } else {
                  const e = t.querySelector(".swiper-wrapper"),
                    n = e.querySelector(`[data-id="${i}"]`);
                  n && e.prepend(n);
                }
              else if ("variant" == e) {
                const e = t.querySelector(".swiper-wrapper"),
                  n = e.querySelector(`[data-id="${i}"]`);
                n &&
                  (e.firstChild.classList.add("u-hide"),
                  n.classList.remove("u-hide"),
                  e.prepend(n));
              }
              const n = document.querySelectorAll(".sticky-add-to-cart__image"),
                r = this.currentVariant.id;
              n.forEach((t) => {
                t.dataset.variantId == r
                  ? t.classList.remove("u-hide")
                  : t.classList.add("u-hide");
              });
            }
          }
          updateURL() {
            if ("false" === this.dataset.updateUrl) return;
            const t = `${this.dataset.url}?variant=${this.currentVariant.id}`;
            window.history.replaceState({}, "", t);
          }
          updateLinks() {
            if (!this.isCardBasedProductForm) return;
            const t = this.closest(".card__content").querySelector(
              ".button--view-product"
            );
            "A" === (null == t ? void 0 : t.tagName) &&
              (t.href =
                this.dataset.url.split("?")[0] +
                `?variant=${this.currentVariant.id}`);
          }
          updateVariantInput() {
            document
              .querySelectorAll(
                `#form-product-${this.uniqueIdentifier}, #form-product-installment-${this.uniqueIdentifier}`
              )
              .forEach((t) => {
                const e = t.querySelector('input[name="id"]');
                (e.value = this.currentVariant.id),
                  e.dispatchEvent(new Event("change", { bubbles: !0 }));
              });
            const t = this.getProductVariantSelects();
            t.length > 1 && this.syncSelectValues(t);
          }
          syncSelectValues(t) {
            t.forEach((t) => {
              t.querySelectorAll("select, fieldset").forEach((t) => {
                if ("SELECT" === t.tagName)
                  this.currentVariant.options[t.dataset.optionPosition - 1] &&
                    (t.value =
                      this.currentVariant.options[
                        t.dataset.optionPosition - 1
                      ]);
                else if ("FIELDSET" === t.tagName) {
                  const e = Array.from(t.querySelectorAll("input")).find(
                    (e) =>
                      e.value ===
                      this.currentVariant.options[t.dataset.optionPosition - 1]
                  );
                  e && (e.checked = !0);
                }
              });
            });
          }
          renderProductInfo() {
            var t;
            const e = document.getElementById(`price-${this.uniqueIdentifier}`);
            e &&
              (e.classList.contains("price--on-sale")
                ? e
                    .querySelectorAll(".price__sale .price-item")
                    .forEach((t) => t.classList.add("skeleton-loading"))
                : e
                    .querySelector(".price__regular")
                    .classList.add("skeleton-loading"));
            const i = document.getElementById(
              `sticky-price-${this.uniqueIdentifier}`
            );
            i &&
              (i.classList.contains("price--on-sale")
                ? i
                    .querySelectorAll(".price__sale .price-item")
                    .forEach((t) => t.classList.add("skeleton-loading"))
                : i
                    .querySelector(".price__regular")
                    .classList.add("skeleton-loading"));
            const r = document.getElementById(
              `pickup-availability-${this.uniqueIdentifier}`
            );
            null == r ||
              null === (t = r.querySelector(".skeleton-loading-wrapper")) ||
              void 0 === t ||
              t.classList.add("skeleton-loading");
            const s = document.getElementById(
              `stock-status-${this.uniqueIdentifier}`
            );
            null == s || s.classList.add("skeleton-loading");
            const o = document.getElementById(
              `pickup-availability-modal-${this.uniqueIdentifier}`
            );
            fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`)
              .then((t) => t.text())
              .then((t) => {
                const a = new DOMParser().parseFromString(t, "text/html"),
                  c = a.getElementById(
                    `price-${this.mainProductUniqueIdentifier}`
                  );
                if (s) {
                  const t = a.getElementById(
                    `stock-status-${this.mainProductUniqueIdentifier}`
                  );
                  t
                    ? (s.classList.remove("u-invisible"),
                      (s.innerHTML = t.innerHTML),
                      (s.classList = t.classList))
                    : null == s || s.classList.add("u-invisible");
                }
                if (
                  (c && e
                    ? (e.classList.remove("u-invisible"),
                      (e.innerHTML = c.innerHTML),
                      (e.classList = c.classList))
                    : null == e || e.classList.add("u-invisible"),
                  i)
                ) {
                  const t = a.getElementById(
                    `sticky-price-${this.mainProductUniqueIdentifier}`
                  );
                  t
                    ? (i.classList.remove("u-invisible"),
                      (i.innerHTML = t.innerHTML),
                      (i.classList = t.classList))
                    : null == i || i.classList.add("u-invisible");
                }
                if (r) {
                  const t = a.getElementById(
                    `pickup-availability-${this.mainProductUniqueIdentifier}`
                  );
                  t &&
                    ((r.innerHTML = t.innerHTML), (r.classList = t.classList));
                }
                if (o) {
                  const t = a.getElementById(
                    `pickup-availability-modal-${this.mainProductUniqueIdentifier}`
                  );
                  t && (o.innerHTML = t.innerHTML);
                }
                const l = document.querySelector(".pickup-availability"),
                  d = document.getElementById("overlay"),
                  u = document.getElementById("pickup-availability-open"),
                  h = document.getElementById("pickup-availability-close");
                u &&
                  document
                    .getElementById("pickup-availability-open")
                    .addEventListener("click", function () {
                      l.classList.add("open"),
                        d.classList.add("open"),
                        document.body.classList.add("active", "minicart"),
                        (0, n.hO)(!0);
                    }),
                  h &&
                    document
                      .getElementById("pickup-availability-close")
                      .addEventListener("click", function () {
                        l.classList.remove("open"),
                          document.body.classList.remove("active", "minicart"),
                          (0, n.hO)(!1),
                          overlay.classList.remove("open", "overlay--all"),
                          (0, n.zx)(l);
                      });
              });
          }
          updateAddToCart() {
            const t = document.querySelectorAll(
              `.form-product-${this.uniqueIdentifier}`
            );
            t &&
              (this.currentVariant.available
                ? t.forEach((t) => {
                    const e = t.querySelector('[name="add"]'),
                      i = t.querySelector(
                        '[name="add"] > span:not(.cart-icon)'
                      );
                    e &&
                      (e.removeAttribute("disabled"),
                      (i.textContent = `${cartStrings.addToCart}`));
                  })
                : t.forEach((t) => {
                    const e = t.querySelector('[name="add"]'),
                      i = t.querySelector(
                        '[name="add"] > span:not(.cart-icon)'
                      );
                    e &&
                      (e.setAttribute("disabled", "disabled"),
                      (i.textContent = `${cartStrings.soldOut}`));
                  }));
          }
          setUnavailable() {
            const t = document.querySelectorAll(
                `.form-product-${this.uniqueIdentifier}`
              ),
              e = document.getElementById(
                `stock-status-${this.uniqueIdentifier}`
              );
            t.forEach((t) => {
              const i = t.querySelector('[name="add"]'),
                n = t.querySelector('[name="add"] > span:not(.cart-icon)');
              i &&
                ((n.textContent = `${cartStrings.unavailable}`),
                i.setAttribute("disabled", "disabled"),
                e && (e.dataset.state = "unavailable"));
            });
            const i = document.getElementById(`price-${this.uniqueIdentifier}`),
              n = document.getElementById(
                `sticky-price-${this.uniqueIdentifier}`
              );
            i && this.setPriceUnavailable(i), n && this.setPriceUnavailable(n);
          }
          setPriceUnavailable(t) {
            t.classList.remove("price--on-sale"),
              t.classList.add("price--sold-out"),
              (t.querySelector(
                ".price__regular .price-item.price-item--regular"
              ).textContent = window.productStrings.price_unavailable);
          }
          getVariantData() {
            return (
              (this.variantData =
                this.variantData ||
                JSON.parse(
                  this.querySelector('[type="application/json"]').textContent
                )),
              this.variantData
            );
          }
          getProductVariantSelects() {
            return document.querySelectorAll(
              `variant-selects[data-section="${this.dataset.section}"][data-product="${this.dataset.product}"]`
            );
          }
        }
        customElements.get("variant-selects") ||
          customElements.define("variant-selects", o);
        class a {
          constructor(t) {
            (this.el = t),
              (this.summary = t.querySelector("summary")),
              (this.content = t.querySelector(".content")),
              (this.animation = null),
              (this.isClosing = !1),
              (this.isExpanding = !1),
              this.summary.addEventListener("click", (t) => this.onClick(t));
          }
          onClick(t) {
            t.preventDefault(),
              (this.el.style.overflow = "hidden"),
              this.isClosing || !this.el.open
                ? this.open()
                : (this.isExpanding || this.el.open) && this.shrink();
          }
          shrink() {
            this.isClosing = !0;
            const t = `${this.el.offsetHeight}px`,
              e = `${this.summary.offsetHeight}px`;
            this.animation && this.animation.cancel(),
              (this.animation = this.el.animate(
                { height: [t, e] },
                { duration: 400, easing: "ease-out" }
              )),
              (this.animation.onfinish = () => this.onAnimationFinish(!1)),
              (this.animation.oncancel = () => (this.isClosing = !1));
          }
          open() {
            (this.el.style.height = `${this.el.offsetHeight}px`),
              (this.el.open = !0),
              window.requestAnimationFrame(() => this.expand());
          }
          expand() {
            this.isExpanding = !0;
            const t = `${this.el.offsetHeight}px`,
              e = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
            this.animation && this.animation.cancel(),
              (this.animation = this.el.animate(
                { height: [t, e] },
                { duration: 400, easing: "ease-out" }
              )),
              (this.animation.onfinish = () => this.onAnimationFinish(!0)),
              (this.animation.oncancel = () => (this.isExpanding = !1));
          }
          onAnimationFinish(t) {
            (this.el.open = t),
              (this.animation = null),
              (this.isClosing = !1),
              (this.isExpanding = !1),
              (this.el.style.height = this.el.style.overflow = "");
          }
        }
        document.querySelectorAll("details.accordion__wrapper").forEach((t) => {
          new a(t);
        });
      },
      157: function (t, e, i) {
        "use strict";
        var n = i(6072),
          r = i(1717),
          s = i(2817),
          o = i.n(s),
          a = i(1434),
          c = (i(4056), i(1092));
        const l = new a.Z(),
          d = () => {
            const t = document.querySelectorAll(
              "#ProductGridContainer .card"
            ).length;
            t < 6 &&
              document
                .querySelectorAll(".banner--large")
                .forEach((t) => (t.style.display = "none")),
              t < 13 &&
                document
                  .querySelectorAll(".banner--small")
                  .forEach((t) => (t.style.display = "none"));
          };
        class u extends HTMLElement {
          constructor() {
            super(),
              (this.onActiveFilterClick = this.onActiveFilterClick.bind(this)),
              (this.debouncedOnSubmit = (0, n.Ds)((t) => {
                this.onSubmitHandler(t);
              }, 500)),
              this.querySelector("form").addEventListener(
                "input",
                this.debouncedOnSubmit.bind(this)
              );
          }
          static setListeners() {
            window.addEventListener("popstate", (t) => {
              const e = t.state ? t.state.searchParams : u.searchParamsInitial;
              e !== u.searchParamsPrev && u.renderPage(e, null, !1);
            });
          }
          static renderPage(t, e) {
            let i =
              !(arguments.length > 2 && void 0 !== arguments[2]) ||
              arguments[2];
            u.searchParamsPrev = t;
            const n = u.getSections();
            document
              .getElementById("ProductGridContainer")
              .classList.add("loading"),
              n.forEach((i) => {
                const n = `${window.location.pathname}?section_id=${i.section}&${t}`,
                  r = (t) => t.url === n;
                u.filterData.some(r)
                  ? u.renderSectionFromCache(r, e)
                  : u.renderSectionFromFetch(n, e);
              }),
              i && u.updateURLHash(t);
          }
          static renderSectionFromFetch(t, e) {
            fetch(t)
              .then((t) => t.text())
              .then((i) => {
                const r = i;
                (u.filterData = [...u.filterData, { html: r, url: t }]),
                  u.renderFilters(r, e),
                  u.renderProductGridContainer(r),
                  document
                    .getElementById("ProductGridContainer")
                    .classList.remove("loading"),
                  (0, n.X5)(
                    document.querySelector("div.grid-archive__outer-container"),
                    document.getElementById("grid-archive-header").offsetHeight
                  );
              });
          }
          static renderSectionFromCache(t, e) {
            const i = u.filterData.find(t).html;
            u.renderFilters(i, e),
              u.renderProductGridContainer(i),
              document
                .getElementById("ProductGridContainer")
                .classList.remove("loading");
          }
          static renderProductGridContainer(t) {
            (document.getElementById("ProductGridContainer").innerHTML =
              new DOMParser()
                .parseFromString(t, "text/html")
                .getElementById("ProductGridContainer").innerHTML),
              d(),
              document
                .getElementById("ProductGridContainer")
                .querySelectorAll(".icon")
                .forEach((t) => {
                  t.classList.add("loaded");
                }),
              (0, n.Sw)(),
              (0, r.f)(),
              (0, c.M)();
          }
          static renderFilters(t, e) {
            const i = new DOMParser().parseFromString(t, "text/html"),
              n =
                "#FacetFiltersForm .js-filter, #FacetAvailabilityForm .js-filter, #FacetSortForm .js-filter",
              r = i.querySelectorAll(n),
              s = document.querySelectorAll(n);
            Array.from(s).forEach((t) => {
              Array.from(r).some((e) => {
                let { id: i } = e;
                return t.id === i;
              }) || t.remove();
            });
            const o = (t) => {
                const i = e ? e.target.closest(".js-filter") : void 0;
                return !!i && t.id === i.id;
              },
              a = Array.from(r).filter((t) => !o(t));
            a.forEach((t, e) => {
              if (document.getElementById(t.id))
                document.getElementById(t.id).innerHTML = t.innerHTML;
              else {
                if (e > 0) {
                  const { className: i, id: n } = a[e - 1];
                  if (t.className === i)
                    return void document.getElementById(n).after(t);
                }
                t.parentElement &&
                  document
                    .querySelector(`#${t.parentElement.id} .js-filter`)
                    .before(t);
              }
            });
            const c = Array.from(r).find(o);
            c &&
              e.target.closest(".js-filter").id &&
              u.renderCounts(c, e.target.closest(".js-filter")),
              u.renderAdditionalElements(i);
          }
          static renderAdditionalElements(t) {
            this.updateElementFromHTML(".facets__active", t),
              this.updateElementFromHTML(".facets__clear", t);
          }
          static updateElementFromHTML(t, e) {
            const i = e.querySelector(t);
            i && (document.querySelector(t).innerHTML = i.innerHTML);
          }
          static renderCounts(t, e) {
            const i = e.querySelector("summary"),
              n = t.querySelector("summary");
            n && i && (i.outerHTML = n.outerHTML);
          }
          static updateURLHash(t) {
            history.pushState(
              { searchParams: t },
              "",
              `${window.location.pathname}${t && "?".concat(t)}`
            );
          }
          static getSections() {
            return [
              { section: document.getElementById("grid-product").dataset.id },
            ];
          }
          createSearchParams(t) {
            const e = new FormData(t);
            return new URLSearchParams(e).toString();
          }
          onSubmitForm(t, e) {
            u.renderPage(t, e);
          }
          onSubmitHandler(t) {
            t.preventDefault();
            const e = document.querySelectorAll("form.facet-form"),
              i = [],
              n = [
                "FacetAvailabilityForm",
                "FacetSortForm",
                "FacetFiltersForm",
                "FacetSearchForm",
              ];
            e.forEach((t) => {
              if (n.includes(t.id)) {
                const e = this.createSearchParams(t);
                "" !== e && i.push(e);
              }
            });
            const r = i.join("&").split("&"),
              s = [...new Set(r)].join("&");
            this.onSubmitForm(s, t);
          }
          onActiveFilterClick(t) {
            t.preventDefault();
            const e = new URL(t.currentTarget.href).search.substring(1);
            u.renderPage(e);
          }
        }
        (u.filterData = []),
          (u.searchParamsInitial = window.location.search.slice(1)),
          (u.searchParamsPrev = window.location.search.slice(1)),
          u.setListeners(),
          customElements.define("facet-filters-form", u);
        class h extends HTMLElement {
          constructor() {
            super(),
              this.querySelector("a").addEventListener("click", (t) => {
                t.preventDefault(),
                  (
                    this.closest("facet-filters-form#facets") ||
                    document.querySelector("facet-filters-form#facets")
                  ).onActiveFilterClick(t);
              });
          }
        }
        customElements.define("facet-remove", h);
        class m extends HTMLElement {
          constructor() {
            super(),
              (this.desktopMedia = window.matchMedia("(min-width: 1024px)")),
              (this.filtersSticky = void 0),
              (this.isStickyAttached = !1);
          }
          connectedCallback() {
            d(),
              this.toggleSidebar(),
              (0, n.Sw)(),
              window.addEventListener("resize", () => {
                this.filtersSticky &&
                !this.desktopMedia.matches &&
                this.isStickyAttached
                  ? this.detachHCSticky()
                  : this.desktopMedia.matches &&
                    !this.isStickyAttached &&
                    this.attachHCSticky();
              });
          }
          setFiltersSticky = () => {
            const t = document.getElementById("main-collection-filters"),
              e = document.getElementById("main-collection-filters-container");
            (null == t ? void 0 : t.clientHeight) <
              (null == e ? void 0 : e.clientHeight) && this.attachHCSticky();
          };
          attachHCSticky = () => {
            let t =
              document.getElementById("grid-archive-header").clientHeight + 10;
            const e = document.querySelector("header").dataset.uxPosition;
            ("hide" !== e && "fixed" !== e) ||
              (t += document.getElementById("nav-wrapper").clientHeight),
              (this.filtersSticky = new (o())("#main-collection-filters", {
                stickTo: "#main-collection-filters-container",
                top: t,
              })),
              (this.isStickyAttached = !0);
          };
          detachHCSticky = () => {
            this.filtersSticky.destroy(), (this.isStickyAttached = !1);
          };
          toggleSidebar = () => {
            const t = window.matchMedia("(max-width: 1024px)");
            document.querySelectorAll(".grid-archive").forEach((e) => {
              const i = e
                  .closest(".shopify-section")
                  .querySelector(".toggle-filtering"),
                r = e.querySelector(".grid-archive__filters-container");
              e.classList.contains(
                "grid-archive__main-container--filters-shown"
              ) &&
                this.desktopMedia.matches &&
                this.setFiltersSticky();
              const s = () => {
                  e.classList.remove(
                    "grid-archive__main-container--filters-shown"
                  ),
                    (0, n.gp)(!1, s);
                },
                o = () => {
                  if (
                    (e.classList.add(
                      "grid-archive__main-container--filters-shown"
                    ),
                    (0, n.gp)(!0, s),
                    !this.filtersSticky && this.desktopMedia.matches)
                  ) {
                    const t =
                      1e3 *
                        ((t) => {
                          if (t.includes(",")) {
                            const e = t
                              .split(",")
                              .map((t) => parseFloat(t.trim()));
                            return Math.max(...e);
                          }
                          return parseFloat(t);
                        })(
                          window
                            .getComputedStyle(
                              document.getElementById(
                                "main-collection-filters-container"
                              )
                            )
                            .getPropertyValue("transition-duration")
                        ) +
                      50;
                    setTimeout(this.setFiltersSticky, t);
                  }
                },
                a = () => {
                  e.classList.remove(
                    "grid-archive__main-container-mobile--filters-shown"
                  ),
                    (0, n.g)(!1, "laptop-down"),
                    l.close(),
                    (0, n.gp)(!1, a);
                },
                c = (t) => {
                  t.target.closest(".facets") ||
                    (a(), r.removeEventListener("click", c));
                };
              i &&
                i.addEventListener("click", () => {
                  t.matches
                    ? (e.classList.add(
                        "grid-archive__main-container-mobile--filters-shown"
                      ),
                      (0, n.g)(!0, "laptop-down"),
                      l.open({ attachElements: [r] }),
                      (0, n.gp)(!0, a),
                      r.addEventListener("click", c))
                    : e.classList.contains(
                        "grid-archive__main-container--filters-shown"
                      )
                    ? s()
                    : o();
                }),
                r &&
                  r
                    .querySelector(".facets__mobile-close")
                    .addEventListener("click", (t) => {
                      t.preventDefault(), a();
                    }),
                t.addEventListener("change", () => {
                  e.classList.contains(
                    "grid-archive__main-container-mobile--filters-shown"
                  ) && a();
                });
            });
          };
          syncSorts = () => {
            if (0 == document.querySelectorAll("#SortByMobile").length) return;
            const t = document.querySelectorAll("#SortBy, #SortByMobile");
            t.forEach((e) => {
              e.addEventListener("change", function (e) {
                t.forEach((t) => {
                  t.value = e.target.value;
                });
                const i = new Event("input");
                document.querySelector("#FacetSortForm").dispatchEvent(i);
              });
            });
          };
        }
        customElements.get("filters-component") ||
          customElements.define("filters-component", m);
      },
      4056: function () {
        class t extends HTMLElement {
          constructor() {
            super(),
              (this.fromSlider = this.querySelectorAll(
                "input[type='range']"
              )[0]),
              (this.toSlider = this.querySelectorAll("input[type='range']")[1]),
              (this.fromInput = this.querySelectorAll(
                "input[type='number']"
              )[0]),
              (this.toInput = this.querySelectorAll("input[type='number']")[1]),
              (this.resetButton = this.querySelector(
                "input[type='button'].range--reset"
              )),
              (this.mobileLabelFrom = this.querySelector(
                ".range--slider-label-from-value"
              )),
              (this.mobileLabelTo = this.querySelector(
                ".range--slider-label-to-value"
              )),
              (this.rangeMin = this.toInput.min),
              (this.rangeMax = this.toInput.max),
              (this.rangeDistance = this.rangeMax - this.rangeMin),
              (this.sliderColor = this.dataset.sliderColor || "#b1b1b1"),
              (this.rangeColor = this.dataset.rangeColor || "#989898"),
              this.setSlider(this.fromSlider.value, this.toSlider.value);
          }
          addListeners() {
            this.fromSlider.addEventListener(
              "input",
              this.updateFromSlider.bind(this)
            ),
              this.toSlider.addEventListener(
                "input",
                this.updateToSlider.bind(this)
              ),
              this.fromInput.addEventListener(
                "input",
                this.updateFromInput.bind(this)
              ),
              this.fromInput.addEventListener(
                "keypress",
                this.validateNumberInput
              ),
              this.toInput.addEventListener(
                "input",
                this.updateToInput.bind(this)
              ),
              this.toInput.addEventListener(
                "keypress",
                this.validateNumberInput
              ),
              this.resetButton.addEventListener(
                "click",
                this.handleResetButtonClick.bind(this)
              );
          }
          validateNumberInput(t) {
            8 === t.charCode ||
              (t.charCode >= 48 && t.charCode <= 57) ||
              t.preventDefault();
          }
          connectedCallback() {
            this.addListeners();
          }
          updateFromInput(t) {
            const [e, i] = this.getParsed(this.fromInput, this.toInput),
              n = null !== e ? e : Number(this.fromInput.min),
              r = i || Number(this.toInput.max);
            n < this.fromInput.min
              ? (this.fromInput.value = Number(this.fromInput.min))
              : n > r && (this.fromInput.value = r),
              this.fromInput.value
                ? this.fromInput.value <= r
                  ? (this.setSlider(this.fromInput.value, !1),
                    (this.mobileLabelFrom.innerHTML = this.fromInput.value),
                    this.showResetButton())
                  : t.stopPropagation()
                : (this.setSlider(n, !1), (this.mobileLabelFrom.innerHTML = n));
          }
          updateToInput(t) {
            const [e, i] = this.getParsed(this.fromInput, this.toInput),
              n = null !== i ? i : Number(this.toInput.max),
              r = e || Number(this.fromInput.min);
            n > this.toInput.max &&
              (this.toInput.value = Number(this.toInput.max)),
              this.toInput.value
                ? r <= this.toInput.value
                  ? (this.setSlider(!1, this.toInput.value),
                    (this.mobileLabelTo.innerHTML = this.toInput.value),
                    this.showResetButton())
                  : t.stopPropagation()
                : (this.setSlider(!1, n), (this.mobileLabelTo.innerHTML = n));
          }
          updateFromSlider() {
            const [t, e] = this.getParsed(this.fromSlider, this.toSlider);
            t > e
              ? ((this.fromSlider.value = e), (this.fromInput.value = e))
              : (this.fromInput.value = t),
              this.fromInput.dispatchEvent(new Event("input", { bubbles: !0 }));
          }
          updateToSlider() {
            const [t, e] = this.getParsed(this.fromSlider, this.toSlider);
            t <= e
              ? (this.toInput.value = e)
              : ((this.toInput.value = t), (this.toSlider.value = t)),
              this.toInput.dispatchEvent(new Event("input", { bubbles: !0 }));
          }
          getParsed(t, e) {
            return [
              t.value ? parseInt(t.value, 10) : null,
              e.value ? parseInt(e.value, 10) : null,
            ];
          }
          setSlider(t, e) {
            !1 !== t && (this.fromSlider.value = t),
              !1 !== e && (this.toSlider.value = e);
            const i = this.fromSlider.value - this.rangeMin,
              n = this.toSlider.value - this.rangeMin,
              r = (i / this.rangeDistance) * 100,
              s = (n / this.rangeDistance) * 100,
              o = 8 - 0.15 * r,
              a = 8 - 0.15 * s;
            this.fillSlider(r, s, o, a);
          }
          fillSlider(t, e, i, n) {
            this.toSlider.style.background = `linear-gradient(\n      to right,\n      ${this.sliderColor} 0%,\n      ${this.sliderColor} calc(${t}% + ${i}px),\n      ${this.rangeColor} calc(${t}% + ${i}px),\n      ${this.rangeColor} calc(${e}% + ${n}px),\n      ${this.sliderColor} calc(${e}% + ${n}px),\n      ${this.sliderColor} 100%)`;
          }
          handleResetButtonClick(t) {
            t.preventDefault(),
              t.stopPropagation(),
              (this.fromInput.value = null),
              (this.toInput.value = null),
              this.fromInput.dispatchEvent(new Event("input", { bubbles: !0 })),
              this.toInput.dispatchEvent(new Event("input", { bubbles: !0 })),
              this.hideResetButton();
          }
          removeListeners() {
            this.fromSlider.removeEventListener(
              "input",
              this.updateFromSlider.bind(this)
            ),
              this.toSlider.removeEventListener(
                "input",
                this.updateToSlider.bind(this)
              ),
              this.fromInput.removeEventListener(
                "input",
                this.updateFromInput.bind(this)
              ),
              this.toInput.removeEventListener(
                "input",
                this.updateToInput.bind(this)
              ),
              this.resetButton.removeEventListener(
                "click",
                this.handleResetButtonClick.bind(this)
              );
          }
          hideResetButton() {
            this.resetButton.classList.add("hidden");
          }
          showResetButton() {
            this.resetButton.classList.remove("hidden");
          }
          disconnectedCallback() {
            this.removeListeners();
          }
        }
        customElements.get("price-range") ||
          customElements.define("price-range", t);
      },
      4487: function (t, e, i) {
        "use strict";
        var n = i(6072);
        const r = new (class {
          constructor() {
            (this.items = Array.from(document.querySelectorAll(".cart-item"))),
              this.items.forEach((t) => this.manageState(t)),
              (this.selectorsToUpdate = [
                ".cart-summary__header",
                "#cart-total-price",
                "#checkout",
                ".cart-summary__free-shipping",
              ]),
              (this.mainCartSelector = ".shopify-section.cart"),
              (this.miniCart = document.getElementById("mini-cart")),
              (this.itemsContainersSelector =
                ".cart-items-container, .cart__empty, .mini-cart--empty"),
              (this.parser = new DOMParser());
          }
          manageState(t) {
            const e = t.getAttribute("data-variant-id");
            t.querySelector(
              ".cart-item-delete, .cart-item__remove"
            ).addEventListener("click", async () => {
              await this.changeCartItem({ id: e, quantity: 0 }), t.remove();
            });
            const i = t.querySelector('input[name="quantity"]');
            if (!i) return;
            const n = t.querySelector('button[name="plus"]'),
              r = t.querySelector('button[name="minus"]'),
              s = t.querySelector('input[name="quantity"]');
            let o = parseInt(i.value);
            n.addEventListener("click", () => {
              (o += 1),
                (i.value = o),
                this.changeCartItem({ id: e, quantity: o });
            }),
              r.addEventListener("click", () => {
                (o -= 1),
                  (i.value = o),
                  this.changeCartItem({ id: e, quantity: o });
              }),
              s.addEventListener("change", (t) => {
                parseInt(t.target.value) > 0
                  ? ((o = parseInt(t.target.value)),
                    this.changeCartItem({ id: e, quantity: o }))
                  : (s.value = o);
              }),
              s.addEventListener("keypress", (t) => {
                ((8 !== t.which && 0 !== t.which && t.which < 48) ||
                  t.which > 57) &&
                  t.preventDefault();
              });
          }
          async changeCartItem(t) {
            const e = {
              ...(0, n.Q2)(),
              body: JSON.stringify({
                line: +t.id,
                quantity: t.quantity,
                sections: "main-cart",
              }),
            };
            fetch(`${routes.cartChange}`, e)
              .then((t) => t.json())
              .then((t) => {
                const e = (e) => {
                  const i = this.parser.parseFromString(e, "text/html");
                  if (0 === t.item_count) {
                    const t = document.querySelector(this.mainCartSelector);
                    t &&
                      (t.innerHTML = i.querySelector(
                        this.mainCartSelector
                      ).innerHTML),
                      this.renderElements(i);
                  } else this.renderItems(i);
                };
                if (t.sections && null !== t.sections["main-cart"])
                  e(t.sections["main-cart"]);
                else {
                  const t = `${window.location.pathname}?section_id=main-cart`;
                  fetch(t)
                    .then((t) => t.text())
                    .then((t) => {
                      e(t);
                    });
                }
                const i = `${window.location.pathname}?section_id=navigation-main`;
                fetch(i)
                  .then((t) => t.text())
                  .then((e) => {
                    const i = this.parser.parseFromString(e, "text/html");
                    if (0 === t.item_count) {
                      const t = document.querySelector("#mini-cart");
                      t &&
                        ((t.innerHTML =
                          i.querySelector("#mini-cart").innerHTML),
                        t.addEventListeners(),
                        t
                          .querySelectorAll(".icon")
                          .forEach((t) => t.classList.add("loaded")));
                    }
                  });
              })
              .catch((t) => {
                console.error(t);
              });
          }
          renderElements(t) {
            this.selectorsToUpdate.forEach((e) => {
              try {
                const i = document.querySelectorAll(e),
                  n = t.querySelector(e);
                i.length &&
                  n &&
                  i.forEach((t) => {
                    n
                      .querySelectorAll(".icon")
                      .forEach((t) => t.classList.add("loaded")),
                      t.replaceWith(n.cloneNode(!0));
                  });
              } catch (t) {
                console.error(`Error updating ${e}`, t);
              }
            });
            const e = t.querySelector(".cart-count");
            document
              .querySelectorAll(
                "#cart-open-block .header__icons--cart-open .cart-count"
              )
              .forEach((t) => {
                e
                  ? (t.classList.contains("visually-hidden") &&
                      t.classList.remove("visually-hidden"),
                    (t.textContent = e.textContent))
                  : t.classList.add("visually-hidden");
              }),
              document
                .querySelector("#cart-open-block .icon")
                .classList.add("loaded");
          }
          renderItems(t) {
            this.renderElements(t);
            const e = Array.from(
                document.querySelectorAll(this.itemsContainersSelector)
              ),
              i = t.querySelector(this.itemsContainersSelector);
            e.forEach((t) => {
              t && t.replaceWith(i.cloneNode(!0));
            }),
              document.querySelectorAll(".cart-item").forEach((t) => {
                t
                  .querySelectorAll(".icon")
                  .forEach((t) => t.classList.add("loaded")),
                  this.manageState(t);
              });
          }
          updateMiniCart(t) {
            return fetch("/?section_id=main-cart")
              .then((t) => t.text())
              .then((e) => {
                this.renderItems(
                  new DOMParser().parseFromString(e, "text/html")
                ),
                  t &&
                    "mini-cart" === cartStrings.uxCart &&
                    this.miniCart &&
                    this.miniCart.open();
              })
              .catch((t) => {
                console.error("Error updating mini cart:", t);
              });
          }
        })();
        (e.Z = r),
          customElements.get("cart-note") ||
            customElements.define(
              "cart-note",
              class extends HTMLElement {
                constructor() {
                  super(),
                    this.querySelector("textarea").addEventListener(
                      "change",
                      (0, n.Ds)((t) => {
                        const e = JSON.stringify({ note: t.target.value });
                        fetch(`${routes.cartUpdate}`, {
                          ...(0, n.Q2)(),
                          body: e,
                        });
                      }, 300)
                    );
                }
              }
            );
      },
      1717: function (t, e, i) {
        "use strict";
        i.d(e, {
          f: function () {
            return s;
          },
        });
        var n = i(6072),
          r = i(4487);
        const s = () => {
          const t = document.querySelectorAll(
              'form[data-type="add-to-cart-form"]'
            ),
            e = document.getElementById("main-cart"),
            i = document.getElementById("mini-cart"),
            s = document.querySelector("body");
          t.length &&
            t.forEach((t) =>
              t.addEventListener("submit", (o) => {
                o.preventDefault(),
                  o.stopPropagation(),
                  o.target.querySelector(
                    'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                  ) &&
                    (o.target.querySelector(
                      'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                    ).textContent = `${cartStrings.addingToCart}`);
                const a = o.target.querySelector('button[type="submit"]'),
                  c = a.querySelector("span.cart-icon"),
                  l = a.querySelector("svg.loading-icon");
                s.classList.remove("added-to-cart"),
                  a.classList.add("added"),
                  (c.style.display = "none"),
                  (l.style.display = "block");
                const d = (0, n.Q2)("javascript");
                (d.headers["X-Requested-With"] = "XMLHttpRequest"),
                  delete d.headers["Content-Type"];
                const u = new FormData(t);
                u.append("sections", "main-cart"),
                  (d.body = u),
                  fetch(`${routes.cartAdd}`, d)
                    .then((t) => t.json())
                    .then(async (t) => {
                      if (t.status) {
                        if (
                          (r.Z.updateMiniCart(!0),
                          (c.style.display = "inline-flex"),
                          (l.style.display = "none"),
                          o.target.querySelector(
                            'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                          ) &&
                            (o.target.querySelector(
                              'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                            ).textContent = `${cartStrings.addToCart}`),
                          "object" == typeof t.description)
                        )
                          return Object.entries(t.description).forEach((t) => {
                            let [e, i] = t;
                            const n = `${i.join(", ")}`;
                            o.target.querySelector(
                              ".main-product__error"
                            ).innerHTML =
                              '<span class="icon loaded">error</span><p>' +
                              n +
                              "</p>";
                          });
                        o.target.querySelector(
                          ".main-product__error"
                        ).innerHTML =
                          '<span class="icon loaded">error</span><p>' +
                          t.description +
                          "</p>";
                      } else {
                        if ("cart" === cartStrings.uxCart)
                          return void (window.location.href =
                            window.routes.cart);
                        if (
                          ((o.target.querySelector(
                            ".main-product__error"
                          ).innerHTML = ""),
                          e && e.classList.add("added"),
                          t.sections && null !== t.sections["main-cart"])
                        )
                          r.Z.renderItems(
                            new DOMParser().parseFromString(
                              t.sections["main-cart"],
                              "text/html"
                            )
                          );
                        else {
                          const t = `${window.location.pathname}?section_id=main-cart`;
                          fetch(t)
                            .then((t) => t.text())
                            .then((t) => {
                              r.Z.renderItems(
                                new DOMParser().parseFromString(t, "text/html")
                              );
                            });
                        }
                        "mini-cart" === cartStrings.uxCart && i && i.open(),
                          o.target.querySelector(
                            'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                          ) &&
                            (o.target.querySelector(
                              'button[type="submit"] > span:not(.cart-icon):not(:empty)'
                            ).textContent = `${cartStrings.addedToCart}`),
                          a.classList.remove("added"),
                          a.classList.add("successful"),
                          (c.style.display = "flex"),
                          (l.style.display = "none"),
                          s.classList.add("added-to-cart");
                      }
                    })
                    .catch((t) => {
                      console.error("Error:", t);
                    });
              })
            );
        };
      },
      1434: function (t, e) {
        "use strict";
        const i = "above-overlay",
          n = new Set();
        e.Z = class {
          isClosingTimer = null;
          attachedElements = new Set();
          constructor() {
            let t =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : document.querySelector("#main-content");
            (this.container = t),
              (this.overlay = document.createElement("div")),
              (this.overlay.innerHTML = "&nbsp;"),
              this.overlay.classList.add("overlay"),
              this.overlay.addEventListener("transitionend", (t) => {
                "opacity" !== t.propertyName ||
                  this.isOpen ||
                  (this.attachedElements &&
                    this.attachedElements.size &&
                    this.attachedElements.forEach((t) => {
                      this.detachElement(t);
                    }),
                  this.afterClosed &&
                    (this.afterClosed(), (this.afterClosed = null)),
                  this.detachOverlay()),
                  "opacity" === t.propertyName &&
                    this.isOpen &&
                    this.afterOpened &&
                    (this.afterOpened(), (this.afterOpened = null));
              }),
              n.add(this);
          }
          attachOverlay() {
            this.container.appendChild(this.overlay);
          }
          detachOverlay() {
            this.container.removeChild(this.overlay);
          }
          async open() {
            let {
              attachElements: t,
              afterOpened: e,
              beforeOpened: n,
            } = arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : {};
            await this.attachOverlay(),
              this.isClosingTimer &&
                (clearTimeout(this.isClosingTimer),
                (this.isClosingTimer = null)),
              n && n(),
              t &&
                (t.forEach((t) => {
                  this.attachedElements.add(t);
                }),
                this.attachedElements.forEach((t) => {
                  t.classList.add(i);
                })),
              this.overlay.classList.add("open"),
              e && (this.afterOpened = e);
          }
          close() {
            let {
              delay: t,
              beforeClosed: e,
              afterClosed: i,
            } = arguments.length > 0 && void 0 !== arguments[0]
              ? arguments[0]
              : {};
            e && e(), (this.afterClosed = i);
            const n = () => {
              this.overlay.classList.remove("open");
            };
            t ? (this.isClosingTimer = setTimeout(n, t)) : n();
          }
          detachElement(t) {
            this.attachedElements.has(t) &&
              t.classList.contains(i) &&
              (t.classList.remove(i), this.attachedElements.delete(t));
          }
          get isOpen() {
            return this.overlay.classList.contains("open");
          }
          onClick() {
            let t =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : () => {};
            t && this.overlay.addEventListener("click", t);
          }
          removeOnClick() {
            let t =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : () => {};
            t && this.overlay.removeEventListener("click", t);
          }
          onHover() {
            let t =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : () => {};
            t &&
              this.overlay.addEventListener("mouseover", (e) => {
                this.isOpen && t(e);
              });
          }
        };
      },
      6072: function (t, e, i) {
        "use strict";
        i.d(e, {
          Ds: function () {
            return l;
          },
          Q2: function () {
            return n;
          },
          Sw: function () {
            return m;
          },
          X5: function () {
            return d;
          },
          g: function () {
            return s;
          },
          gp: function () {
            return c;
          },
          hO: function () {
            return r;
          },
          zx: function () {
            return h;
          },
        });
        const n = function () {
            return {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: `application/${
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : "json"
                }`,
              },
            };
          },
          r = function () {
            let t =
              arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            const e = window.innerWidth - document.body.offsetWidth,
              i = document.getElementById("nav-wrapper");
            t
              ? (document.body.classList.add("no-scroll"),
                (document.body.style.paddingRight = e + "px"),
                (i.style.paddingRight = e + "px"))
              : (document.body.classList.remove("no-scroll"),
                (document.body.style.paddingRight = "0px"),
                (i.style.paddingRight = "0px"));
          },
          s = function () {
            let t = arguments.length > 1 ? arguments[1] : void 0;
            arguments.length > 0 && void 0 !== arguments[0] && arguments[0]
              ? document.body.classList.add(`no-scroll--${t}`)
              : document.body.classList.remove(`no-scroll--${t}`);
          };
        let o = () => {};
        const a = (t) => {
            "Escape" === t.key &&
              (o(), window.removeEventListener("keydown", a));
          },
          c = function () {
            let t =
                arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
              e = arguments.length > 1 ? arguments[1] : void 0;
            e && (o = e),
              t && window.addEventListener("keydown", a),
              t || window.removeEventListener("keydown", a);
          };
        function l(t, e) {
          const i = this;
          let n;
          return function () {
            for (var r = arguments.length, s = new Array(r), o = 0; o < r; o++)
              s[o] = arguments[o];
            clearTimeout(n),
              (n = setTimeout(function () {
                return t.apply(i, s);
              }, e));
          };
        }
        function d(t) {
          let e =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0;
          const i = document.getElementById("nav-wrapper"),
            n = document
              .querySelector(".header")
              .getAttribute("data-ux-position"),
            r = t.getBoundingClientRect().top;
          window.scrollTo({
            top:
              "off" !== n
                ? r + window.scrollY - e + parseFloat(i.style.marginTop)
                : r + window.scrollY - e,
            behavior: "smooth",
          });
        }
        document.querySelectorAll(".local-scroll").forEach((t) => {
          t.addEventListener("click", (t) => {
            t.preventDefault(), t.stopPropagation();
            const e = t.target.getAttribute("href");
            d(document.querySelector(e));
          });
        });
        const u = {};
        function h(t) {
          document.removeEventListener("focusin", u.focusin),
            document.removeEventListener("focusout", u.focusout),
            document.removeEventListener("keydown", u.keydown),
            t && t.focus();
        }
        const m = () => {
          const t = document.querySelector(".grid-archive__content");
          document.querySelector(".grid-archive__subnav .cols") &&
            (document.querySelectorAll(".view-icon-desktop").forEach((e) => {
              e.onclick = function () {
                document.querySelectorAll(".view-icon-desktop").forEach((t) => {
                  t.classList.remove("active");
                }),
                  this.classList.add("active"),
                  localStorage.setItem("columns-desktop", e.dataset.columns),
                  4 == e.dataset.columns
                    ? (t.classList.remove(
                        "grid-archive__content--three-column"
                      ),
                      t.classList.add("grid-archive__content--four-column"))
                    : (t.classList.add("grid-archive__content--three-column"),
                      t.classList.remove("grid-archive__content--four-column"));
              };
            }),
            document.querySelectorAll(".view-icon-mobile").forEach((e) => {
              e.onclick = function () {
                document.querySelectorAll(".view-icon-mobile").forEach((t) => {
                  t.classList.remove("active");
                }),
                  this.classList.add("active"),
                  localStorage.setItem("columns-mobile", e.dataset.columns),
                  1 == e.dataset.columns
                    ? (t.classList.remove("grid-archive__content--two-column"),
                      t.classList.add("grid-archive__content--one-column"))
                    : (t.classList.add("grid-archive__content--two-column"),
                      t.classList.remove("grid-archive__content--one-column"));
              };
            }),
            4 == localStorage.getItem("columns-desktop") &&
              (t.classList.remove("grid-archive__content--three-column"),
              t.classList.add("grid-archive__content--four-column"),
              document.querySelector(".three-col").classList.remove("active"),
              document.querySelector(".four-col").classList.add("active")),
            1 == localStorage.getItem("columns-mobile") &&
              (t.classList.remove("grid-archive__content--two-column"),
              t.classList.add("grid-archive__content--one-column"),
              document.querySelector(".two-col").classList.remove("active"),
              document.querySelector(".one-col").classList.add("active")));
        };
      },
      5122: function () {},
    },
    i = {};
  function n(t) {
    var r = i[t];
    if (void 0 !== r) return r.exports;
    var s = (i[t] = { exports: {} });
    return e[t].call(s.exports, s, s.exports, n), s.exports;
  }
  (n.m = e),
    (t = []),
    (n.O = function (e, i, r, s) {
      if (!i) {
        var o = 1 / 0;
        for (d = 0; d < t.length; d++) {
          (i = t[d][0]), (r = t[d][1]), (s = t[d][2]);
          for (var a = !0, c = 0; c < i.length; c++)
            (!1 & s || o >= s) &&
            Object.keys(n.O).every(function (t) {
              return n.O[t](i[c]);
            })
              ? i.splice(c--, 1)
              : ((a = !1), s < o && (o = s));
          if (a) {
            t.splice(d--, 1);
            var l = r();
            void 0 !== l && (e = l);
          }
        }
        return e;
      }
      s = s || 0;
      for (var d = t.length; d > 0 && t[d - 1][2] > s; d--) t[d] = t[d - 1];
      t[d] = [i, r, s];
    }),
    (n.n = function (t) {
      var e =
        t && t.__esModule
          ? function () {
              return t.default;
            }
          : function () {
              return t;
            };
      return n.d(e, { a: e }), e;
    }),
    (n.d = function (t, e) {
      for (var i in e)
        n.o(e, i) &&
          !n.o(t, i) &&
          Object.defineProperty(t, i, { enumerable: !0, get: e[i] });
    }),
    (n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (n.j = 6955),
    (function () {
      var t = { 6955: 0, 7658: 0, 7954: 0, 8973: 0, 3625: 0, 7317: 0 };
      n.O.j = function (e) {
        return 0 === t[e];
      };
      var e = function (e, i) {
          var r,
            s,
            o = i[0],
            a = i[1],
            c = i[2],
            l = 0;
          if (
            o.some(function (e) {
              return 0 !== t[e];
            })
          ) {
            for (r in a) n.o(a, r) && (n.m[r] = a[r]);
            if (c) var d = c(n);
          }
          for (e && e(i); l < o.length; l++)
            (s = o[l]), n.o(t, s) && t[s] && t[s][0](), (t[s] = 0);
          return n.O(d);
        },
        i = (self.webpackChunkworkflow = self.webpackChunkworkflow || []);
      i.forEach(e.bind(null, 0)), (i.push = e.bind(null, i.push.bind(i)));
    })(),
    n.O(void 0, [1216], function () {
      return n(5122);
    });
  var r = n.O(void 0, [1216], function () {
    return n(157);
  });
  r = n.O(r);
})();




